module.exports = __webpack_public_path__ + "static/media/Purchase of shares.9f89cee2.jpg";